export const classNames = (classNamesArray: any[]): string => {
	return classNamesArray.filter(Boolean).join(' ');
};
